import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Title } from "../../../../../../themes/Default/components/Title";
import { groupProgressManagement } from "../../../../../../hooks/api/GroupProgressManagement/GroupProgressManagement";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { toast } from "react-toastify";

const AddProgressTypeOption = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { groupProgressId } = useParams();
    const { groupProgressTypeId } = useParams();
    const { settingsGroupProgressTypeOptionId } = useParams();
    const [groupProgressName, setGroupProgressName] = useState("");

    const { 
        useViewGroupProgressMutation,
        useViewGroupGroupProgressTypeOptionMutation,
        useUpdateGroupGroupProgressTypeOptionMutation
    } = groupProgressManagement;

    const [viewGroupProgress] = useViewGroupProgressMutation();
    const [viewGroupProgressType] = useViewGroupGroupProgressTypeOptionMutation();
    const [updateGroupProgressType] = useUpdateGroupGroupProgressTypeOptionMutation();

    const tabs = [
        { title: t("plans.title"), onClick: () => gotoPlansTab() },
        { title: t("groupTypes.title"), onClick: () => gotoTypeTab() },
        { title: t("groups.progress"), isActive: true },
        { title: t("groups.progressTest"), onClick: () => gotoProgressTestTab() },
    ];

    const gotoTypeTab = () => {
        navigate("/settings/groups/types");
    };

    const gotoPlansTab = () => {
        navigate("/settings/groups/plans");
    };
    
    const gotoProgressTestTab = () => {
        navigate("/settings/groups/progress-tests");
    };


    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        updateGroupProgressType({ body: values, groupProgressTypeId, settingsGroupProgressTypeOptionId }).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/groups/progress/" + groupProgressId + "/type/" + groupProgressTypeId + "/options/add");
            }
        });
    };

    useEffect(() => {
        viewGroupProgress(groupProgressId).then((result) => {
            setGroupProgressName(result?.data?.name);
        });

        console.log(groupProgressTypeId);
        console.log(settingsGroupProgressTypeOptionId);
        viewGroupProgressType({ groupProgressTypeId, settingsGroupProgressTypeOptionId }).then((result) => {
            formRef.current.setValues(result?.data);
        });
     }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to={"/settings/groups/progress/"+groupProgressId+"/type/add"}/>
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{groupProgressName}</Title>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("groups.title")} />
                    <Link title={t("Napredak")} />
                    <Link title={t('details')} isActive={true}/>
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        name: "", 
                    }}
                    onSubmit={(values) => {
                        onSaved(values);
                    }}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input 
                                        name="name" 
                                        label={t('groups.name')} 
                                        value={values.name} 
                                        onChange={handleChange} 
                                        required={true} 
                                        error={formErrors?.name}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddProgressTypeOption;